<template>
  <svg
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2844 12.3934H4.71415C2.48261 12.3934 0.666992 10.5708 0.666992 8.34388C0.666992 6.31069 2.17392 4.61975 4.12801 4.33512C4.49407 1.97428 6.54159 0.166016 9.0002 0.166016C11.4588 0.166016 13.5063 1.97428 13.8749 4.33512C15.8267 4.61976 17.3337 6.3109 17.3337 8.34388C17.3337 10.5708 15.5182 12.3934 13.2842 12.3934H13.2844ZM4.71415 5.90411C3.36987 5.90411 2.27921 6.99729 2.27921 8.34388C2.27921 9.68564 3.36987 10.7788 4.71415 10.7788H13.2844C14.6286 10.7788 15.7216 9.68564 15.7216 8.34388C15.7216 6.99729 14.6284 5.90411 13.2844 5.90411H13.1265C12.6817 5.90411 12.3205 5.54539 12.3205 5.09557C12.3205 3.26812 10.8304 1.77802 9.00061 1.77802C7.16847 1.77802 5.68072 3.26812 5.68072 5.09557C5.68072 5.5452 5.3195 5.90411 4.87217 5.90411H4.71415Z"
      fill="#858C9A"
    />
  </svg>
</template>
